/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck - Legacy route configuration with components that may not have all required props
// This file contains 186 instances of components being instantiated without all required props.
// This was the behavior in the original JavaScript code and is preserved during migration.
// TODO: Fix component prop requirements in a separate refactoring effort
import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { getHashFromLandingPage } from "@/containers/LandingPageHelper/LandingPageHelper";
import type { RootState } from "@/types/RootState";
import type { RouteConfig } from "@/types/RouteConfig";

// this is fallback component cant make it lazy loading
import Loading from "@/components/ReactBootstrap/LoaderSpinner/Loading";

const RMADeclaration = React.lazy(() =>
  import("@/cleanup/pages/RMADeclaration/RMADeclaration")
);
const RMADeclarationManage = React.lazy(() =>
  import("@/cleanup/pages/RMADeclaration/RMADeclarationManage")
);
const RMADeclarationView = React.lazy(() =>
  import("@/cleanup/pages/RMADeclaration/RMADeclarationView")
);
const RMADeclarationViewDetails = React.lazy(() =>
  import("@/cleanup/pages/RMADeclaration/RMADeclarationViewDetails")
);
const MetarWeatherLocation = React.lazy(() =>
  import("@/cleanup/pages/MetarWeatherLocation/MetarWeatherLocation")
);
const MetarWeatherLocationManage = React.lazy(() =>
  import("@/cleanup/pages/MetarWeatherLocation/MetarWeatherLocationManage")
);
const ImportTrackerSettings = React.lazy(() =>
  import("@cleanup/pages/ImportTrackerSettingsPage/ImportTrackerSettingsPage")
);
const ImportInfrastructureSettings = React.lazy(() =>
  import("@cleanup/pages/ImportInfrastructurePage/ImportInfrastructurePage")
);
const SystemTagList = React.lazy(() =>
  import("@/cleanup/pages/SystemTag/SystemTagList")
);
const SystemTagManage = React.lazy(() =>
  import("@/cleanup/pages/SystemTag/SystemTagManage")
);
const PartnerTagManage = React.lazy(() =>
  import("@cleanup/pages/PartnerTag/PartnerTagManage")
);
const PartnerTagList = React.lazy(() =>
  import("@cleanup/pages/PartnerTag/PartnerTagList")
);
const SalesforceAccount = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceAccount")
);
const SalesforceContact = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceContact")
);
const SalesforceLead = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceLead")
);
const SalesforceOpportunity = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceOpportunity")
);
const SalesforceOpportunityDetail = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceOpportunityDetail/SalesforceOpportunityDetail")
);
const SalesforceAccountDetail = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceAccountDetail/SalesforceAccountDetail")
);
const SalesforceQuote = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceQuote")
);
const SalesforceQuoteLineItem = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceQuoteLineItem")
);
const SalesforceQuoteDetail = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceQuoteDetail/SalesforceQuoteDetail")
);
const SalesforceChannelPartner = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceChannelPartner")
);
const SalesforceChannelPartnerDetail = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceChannelPartnerDetail/SalesforceChannelPartnerDetail")
);
const SalesforceUser = React.lazy(() =>
  import("@/pages/Salesforce/SalesforceUser")
);
const ImpartnerAccount = React.lazy(() =>
  import("@/pages/Impartner/ImpartnerAccount")
);
const ImpartnerChannelPartner = React.lazy(() =>
  import("@/pages/Impartner/ImpartnerChannelPartner")
);
const ImpartnerUser = React.lazy(() =>
  import("@/pages/Impartner/ImpartnerUser")
);
const NoAccessPage = React.lazy(() =>
  import("@/cleanup/pages/NoAccessPage/NoAccessPage")
);
const PrivateCellular = React.lazy(() =>
  import("@/cleanup/pages/PrivateCellular/PrivateCellular")
);
const HarvestedCellular = React.lazy(() =>
  import("@/cleanup/pages/HarvestedCellular/HarvestedCellular")
);
const CellularAccount = React.lazy(() =>
  import("@cleanup/pages/CellularAccount/CellularAccount")
);
const CellularSim = React.lazy(() =>
  import("@/cleanup/pages/CellularSim/CellularSim")
);
const CellularAccountManage = React.lazy(() =>
  import("@cleanup/pages/CellularAccount/CellularAccountManage")
);
const AutomationRule = React.lazy(() =>
  import("@/cleanup/pages/AutomationRule/AutomationRule")
);
const AutomationRuleCreate = React.lazy(() =>
  import(
    "@/cleanup/pages/AutomationRule/AutomationRuleCreate/AutomationRuleCreate"
  )
);
const AutomationRuleUpdate = React.lazy(() =>
  import(
    "@/cleanup/pages/AutomationRule/AutomationRuleUpdate/AutomationRuleUpdate"
  )
);
const DeviceUsageProfileManage = React.lazy(() =>
  import("@pages/DeviceUsageProfile/DeviceUsageProfileManage")
);
const ProfileComparePage = React.lazy(() =>
  import("@pages/DeviceUsageProfile/Compare/ProfileComparePage")
);
const AssetLinkPage = React.lazy(() =>
  import("@/cleanup/pages/AssetLinkPage/AssetLinkPage")
);
const SSOSetting = React.lazy(() => import("@pages/SingleSignOn/SSOSetting"));
const UserAssertionMappingUpdate = React.lazy(() =>
  import("@pages/SingleSignOn/UserAssertionMappingUpdate")
);
const CSMInfoUpdate = React.lazy(() =>
  import("@/cleanup/pages/CSMInfo/CSMInfoUpdate/CSMInfoUpdate")
);
const CSMComment = React.lazy(() =>
  import("@/cleanup/pages/CSMComment/CSMComment")
);
const CSMCommentCreate = React.lazy(() =>
  import("@/cleanup/pages/CSMComment/CSMCommentCreate/CSMCommentCreate")
);
const CSMCommentUpdate = React.lazy(() =>
  import("@/cleanup/pages/CSMComment/CSMCommentUpdate/CSMCommentUpdate")
);
const PriceListImportForm = React.lazy(() =>
  import("@/pages/PriceList/PriceListImportForm")
);

const PriceListItem = React.lazy(() =>
  import("@/pages/PriceListItem/PriceListItem")
);

import LocationMismatch from "@/pages/WifiCellularMismatch/LocationMismatch";
import AppLayout from "@/containers/AdminLayout/AppLayout";

const ForbiddenPage = React.lazy(() =>
  import("@pages/ErrorPages/ForbiddenPage")
);
const PermissionPage = React.lazy(() =>
  import("@cleanup/pages/PermissionPage/PermissionPage")
);
const NotFoundPage = React.lazy(() => import("@pages/ErrorPages/NotFoundPage"));
const BadRequestPage = React.lazy(() =>
  import("@pages/ErrorPages/BadRequestPage")
);

const Helpdesk = React.lazy(() => import("@pages/Helpdesk/Helpdesk"));
const ZendeskSupportTicket = React.lazy(() =>
  import("@/cleanup/pages/ZendeskSupportTicket/ZendeskSupportTicket")
);
const ZendeskTicket = React.lazy(() =>
  import("@/cleanup/pages/ZendeskTicket/ZendeskTicket")
);
const ZendeskOrderTicket = React.lazy(() =>
  import("@/cleanup/pages/ZendeskOrderTicket/ZendeskOrderTicket")
);
const MaintenanceDonePage = React.lazy(() =>
  import("@/cleanup/pages/MaintenanceDonePage/MaintenanceDonePage")
);
const MaintenanceUpcomingPage = React.lazy(() =>
  import("@/cleanup/pages/MaintenanceUpcomingTable/MaintenanceUpcomingPage")
);
const Invoicing = React.lazy(() => import("@pages/Invoicing/Invoicing"));
const Support = React.lazy(() => import("@/cleanup/pages/Support/Support"));
const InvoiceDetail = React.lazy(() =>
  import("@pages/InvoiceDetail/InvoiceDetail")
);
const OrganisationVisionPartnerUpdate = React.lazy(() =>
  import("@pages/PartnerUpdate/OrganisationVisionPartnerUpdate")
);
const SigfoxAccountDeviceTypeInfo = React.lazy(() =>
  import("@pages/SigfoxAccountDeviceTypeInfo/SigfoxAccountDeviceTypeInfo")
);
const SigfoxAccountUpdate = React.lazy(() =>
  import("@pages/SigfoxAccountUpdate/SigfoxAccountUpdate")
);
const AlertRuleUpdate = React.lazy(() =>
  import("@pages/AlertUpdate/AlertRuleUpdate")
);
const RoleManagerUpdate = React.lazy(() =>
  import("@pages/RoleManagerUpdate/RoleManagerUpdate")
);
const InvoiceAddendum = React.lazy(() =>
  import("@pages/InvoiceAddendum/InvoiceAddendum")
);
const OrganizationLandingPage = React.lazy(() =>
  import("@pages/DefaultLandingPage/OrganizationLandingPage")
);
const GeozoneStatistics = React.lazy(() =>
  import("@pages/GeozoneVisit/GeozoneStatistics")
);
const UserUpdatePage = React.lazy(() =>
  import("@cleanup/pages/UserUpdate/UserUpdatePage")
);
const Profile = React.lazy(() => import("@pages/Profile/Profile"));
const TrackerProductDetail = React.lazy(() =>
  import("@pages/TrackerProductDetail/TrackerProductDetail")
);
const ProductAutoUpgrade = React.lazy(() =>
  import("@/cleanup/pages/ProductAutoUpgrade/ProductAutoUpgrade")
);
const ProductAutoUpgradeDetail = React.lazy(() =>
  import("@/cleanup/pages/ProductAutoUpgrade/ProductAutoUpgradeDetail")
);
const ProductRegexpFilter = React.lazy(() =>
  import("@cleanup/pages/ProductRegexpFilter/ProductRegexpFilter")
);
const ProductRegexpFilterDetail = React.lazy(() =>
  import("@cleanup/pages/ProductRegexpFilter/ProductRegexpFilterDetail")
);
const UpdateDeviceTag = React.lazy(() =>
  import("@pages/AssetTagManage/UpdateDeviceTag")
);
const UpdateGeozoneTag = React.lazy(() =>
  import("@/cleanup/pages/GeozoneTagManage/UpdateGeozoneTag")
);
const BiDashBoardManagePage = React.lazy(() =>
  import("@cleanup/pages/BiDashBoardManage/BiDashBoardManagePage")
);
const CustomI18nMessages = React.lazy(() =>
  import("@pages/CustomI18nMessages/CustomI18nMessages")
);
const CustomI18nMessagesManage = React.lazy(() =>
  import("@pages/CustomI18nMessages/CustomI18nMessagesManage")
);
const MainManufacturingInfo = React.lazy(() =>
  import("@pages/ManufacturingInfo/MainManufacturingInfo")
);
const AuditLog = React.lazy(() => import("@/cleanup/pages/AuditLog/AuditLog"));
const AuditLogView = React.lazy(() =>
  import("@/cleanup/pages/AuditLog/AuditLogView")
);
const LoginMobile = React.lazy(() => import("@pages/Login/LoginMobile"));
const Stock = React.lazy(() => import("@/cleanup/pages/Stock/Stock"));
const StockMovement = React.lazy(() => import("@/cleanup/pages/StockMovement/StockMovement"));
const StockMovementView = React.lazy(() => import("@/cleanup/pages/StockMovement/StockMovementView"));
const StockUpdate = React.lazy(() => import("@pages/StockUpdate/StockUpdate"));
const OrganisationDemoSettings = React.lazy(() =>
  import("@/cleanup/pages/OrganisationDemoSettings/OrganisationDemoSettings")
);
const OrganisationDemoSettingsManage = React.lazy(() =>
  import(
    "@/cleanup/pages/OrganisationDemoSettings/OrganisationDemoSettingsManage"
  )
);
const LegalDocument = React.lazy(() => import("@pages/Legal/LegalDocument"));
const LegalDocumentTemplate = React.lazy(() =>
  import("@pages/Legal/LegalDocumentTemplate")
);
const LegalDocumentTemplateManage = React.lazy(() =>
  import("@pages/Legal/LegalDocumentTemplateManage")
);
const LegalDocumentImport = React.lazy(() =>
  import("@pages/Legal/LegalDocumentImport")
);
const LegalDocumentSend = React.lazy(() =>
  import("@pages/Legal/LegalDocumentSend")
);
const LocationHistory = React.lazy(() =>
  import("@pages/LocationHistory/LocationHistory")
);
const QuotationDetail = React.lazy(() =>
  import("@pages/QuotationDetail/QuotationDetail")
);
const InvoicingOperations = React.lazy(() =>
  import("@cleanup/pages/InvoicingOperations/InvoicingOperations")
);
const InvoicingOperationsDetail = React.lazy(() =>
  import("@cleanup/pages/InvoicingOperations/InvoicingOperationsDetail")
);
const GeolayerGenerator = React.lazy(() =>
  import("@cleanup/pages/GeolayerGenerator/GeolayerGenerator")
);
const GeolayerGeneratorManage = React.lazy(() =>
  import("@cleanup/pages/GeolayerGenerator/GeolayerGeneratorManage")
);
const LegalDocumentView = React.lazy(() =>
  import("@pages/Legal/LegalDocumentView")
);
const ProcessStatistics = React.lazy(() =>
  import("@pages/ProcessDashboard/ProcessStatistics")
);
const Processes = React.lazy(() => import("@pages/ProcessDashboard/Processes"));

const Login = React.lazy(() => import("../../pages/Login/Login"));
const OAuth2Authorize = React.lazy(() =>
  import("../../pages/OAuth2Authorize/OAuth2Authorize")
);
const Logout = React.lazy(() => import("../../pages/Logout/Logout"));
const Confirm = React.lazy(() => import("../../pages/Confirm/Confirm"));
const ForgetPassword = React.lazy(() =>
  import("../../pages/ForgetPassword/ForgetPassword")
);
const ChangePassword = React.lazy(() =>
  import("../../pages/ChangePassword/ChangePassword")
);
const EmailVerification = React.lazy(() =>
  import("../../pages/EmailVerification/EmailVerification")
);
const UnlockAccount = React.lazy(() =>
  import("../../pages/UnlockAccount/UnlockAccount")
);
const ChangePasswordExpired = React.lazy(() =>
  import("../../pages/ChangePasswordExpired/ChangePasswordExpired")
);
const CompleteUserInfo = React.lazy(() =>
  import("../../pages/CompleteUserInfo/CompleteUserInfo")
);
const ConfirmDCR = React.lazy(() =>
  import("../../pages/ConfirmDCR/ConfirmDCR")
);
const ActivateInvitation = React.lazy(() =>
  import("../../pages/ActivateInvitation/ActivateInvitation")
);

const AssetMap = React.lazy(() =>
  import("@/cleanup/pages/AssetMapPage/AssetMapPage")
);
const AssetBrowserPage = React.lazy(() =>
  import("@/cleanup/pages/AssetBrowserPage/AssetBrowserPage")
);
const AssetListReact = React.lazy(() =>
  import("../../pages/AssetList/AssetList")
);
const DeviceDetailPage = React.lazy(() =>
  import("../../pages/DeviceDetailPage/DeviceDetailPage")
);
const ApiDocs = React.lazy(() => import("../../pages/ApiDocs/ApiDocs"));

const ClientAppApi = React.lazy(() =>
  import("../../pages/ClientAppApi/ClientAppApi")
);
const RoleManager = React.lazy(() =>
  import("../../cleanup/pages/RoleManager/RoleManager")
);
const InternalApi = React.lazy(() =>
  import("../../pages/InternalApi/InternalApi")
);
const InternalPlan = React.lazy(() =>
  import("../../pages/InternalPlan/InternalPlan")
);
const Utilization = React.lazy(() =>
  import("../../cleanup/pages/Utilization/Utilization")
);
const Manufacturing = React.lazy(() =>
  import("../../pages/Manufacturing/Manufacturing")
);
const ManufacturingOrderDetail = React.lazy(() =>
  import("../../pages/Manufacturing/ManufacturingOrderDetail")
);
const SuezDashBoard = React.lazy(() =>
  import("../../pages/SuezDashBoard/SuezDashBoard")
);
const Report = React.lazy(() => import("@cleanup/pages/Report/Report"));
const CreateReport = React.lazy(() =>
  import("../../pages/CreateReport/CreateReport")
);
const ReportSchedule = React.lazy(() =>
  import("@/cleanup/pages/ReportSchedule/ReportSchedule")
);
const ActiveAlertsDashboard = React.lazy(() =>
  import("../../pages/ActiveAlertsDashboard/ActiveAlertsDashboard")
);
const HistoricalAlertsDashboard = React.lazy(() =>
  import("../../pages/HistoricalAlertsDashboard/HistoricalAlertsDashboard")
);
const ActiveAlertsList = React.lazy(() =>
  import("../../cleanup/pages/ActiveAlertsList/ActiveAlertsList")
);
const HistoricalAlertsList = React.lazy(() =>
  import("../../cleanup/pages/HistoricalAlertsList/HistoricalAlertsList")
);
const GeozonesDashboard = React.lazy(() =>
  import("../../pages/GeozonesDashboard/GeozonesDashboard")
);

const GeozonesList = React.lazy(() =>
  import("@cleanup/pages/GeozonesList/GeozonesList")
);

const GeozonesTagList = React.lazy(() =>
  import("@cleanup/pages/GeozonesTagList/GeozonesTagList")
);
const GeozoneTagManage = React.lazy(() =>
  import("../../cleanup/pages/GeozoneTagManage/GeozoneTagManage")
);
const AssetTagManage = React.lazy(() =>
  import("../../pages/AssetTagManage/AssetTagManage")
);
const Geolayers = React.lazy(() => import("../../pages/Geolayers/Geolayers"));
const GeolayerUpdate = React.lazy(() =>
  import("../../pages/GeolayerUpdate/GeolayerUpdate")
);
const SiteMaps = React.lazy(() => import("../../pages/SiteMaps/SiteMaps"));
const SiteMapUpdate = React.lazy(() =>
  import("../../pages/SiteMapUpdate/SiteMapUpdate")
);
const AssetTrackersAdmin = React.lazy(() =>
  import("@cleanup/pages/TrackersAdmin/TrackerAdminPage")
);

const FactoryUpload = React.lazy(() =>
  import("../../pages/FactoryUpload/FactoryUpload")
);
const FactoryUploadUpdate = React.lazy(() =>
  import("../../pages/FactoryUpload/FactoryUploadUpdate")
);
const CreateFactoryOrder = React.lazy(() =>
  import("../../pages/FactoryUpload/CreateFactoryOrder")
);
const AreasUpdate = React.lazy(() =>
  import("../../pages/AreasUpdate/AreasUpdate")
);
const InfrastructuresUpdate = React.lazy(() =>
  import("../../pages/InfrastructuresUpdate/InfrastructuresUpdate")
);
const Infrastructure = React.lazy(() =>
  import("../../pages/Infrastructure/Infrastructure")
);
const AlertRule = React.lazy(() =>
  import("../../cleanup/pages/AlertRule/AlertRule")
);
const UtilizationKpi = React.lazy(() =>
  import("../../cleanup/pages/UtilizationKpi/UtilizationKpi")
);
const UtilizationKpiUpdate = React.lazy(() =>
  import("../../pages/UtilizationKpiUpdate/UtilizationKpiUpdate")
);
const VisibilityFilters = React.lazy(() =>
  import("../../cleanup/pages/VisibilityFilters/VisibilityFilters")
);
const ManageVisibilityFilters = React.lazy(() =>
  import("../../pages/VisibilityFilters/ManageVisibilityFilters")
);
const OrganisationFilters = React.lazy(() =>
  import("../../cleanup/pages/OrganisationFilters/OrganisationFilters")
);
const ManageOrganisationFilters = React.lazy(() =>
  import(
    "../../pages/VisibilityFilters/OrganisationFilters/ManageOrganisationFilters"
  )
);
const FlowDefinition = React.lazy(() =>
  import("../../cleanup/pages/FlowDefinition/FlowDefinition")
);
const FlowSettings = React.lazy(() =>
  import("../../pages/FlowSettings/FlowSettings")
);
const ProcessDefinition = React.lazy(() =>
  import("../../pages/ProcessDefinition/ProcessDefinition")
);
const ProcessDefinitionUpdate = React.lazy(() =>
  import("../../pages/ProcessDefinitionUpdate/ProcessDefinitionUpdate")
);
const User = React.lazy(() => import("../../pages/User/User"));
const ImageLibrary = React.lazy(() =>
  import("../../cleanup/pages/ImageLibrary/ImageLibrary")
);
const ImageLibraryManage = React.lazy(() =>
  import("../../cleanup/pages/ImageLibrary/ImageLibraryManage")
);
const Organization = React.lazy(() =>
  import("../../cleanup/pages/Organization/Organization")
);
const OrganizationDetail = React.lazy(() =>
  import("../../pages/OrganizationDetail/OrganizationDetail")
);
const ProductPlan = React.lazy(() =>
  import("../../pages/ProductPlan/ProductPlan")
);
const TrackerProduct = React.lazy(() =>
  import("../../cleanup/pages/TrackerProduct/TrackerProduct")
);
const BatteryCalculator = React.lazy(() =>
  import("../../cleanup/pages/BatteryCalculator/BatteryCalculator")
);

const EndOfLifeDevice = React.lazy(() =>
  import("../../cleanup/pages/EndOfLifeDevice/EndOfLifeDevice")
);
const FailedTrackers = React.lazy(() =>
  import("../../pages/FailedTrackers/FailedTrackers")
);
const BeaconSettings = React.lazy(() =>
  import("../../pages/BeaconSettings/BeaconSettings")
);
const Wifi = React.lazy(
  () => import("@/cleanup/pages/Wifi/Wifi")
);
const DiagnosticPage = React.lazy(() =>
  import("../../pages/Diagnostic/DiagnosticPage")
);
const CustomBranding = React.lazy(() =>
  import("../../pages/CustomBranding/CustomBranding")
);
const BLESensorList = React.lazy(() =>
  import("../../cleanup/pages/BLESensorList/BLESensorList")
);
const ImportBLESensors = React.lazy(() =>
  import("../../cleanup/pages/BLESensorList/ImportBLESensors")
);
const BLESensorUpdate = React.lazy(() =>
  import("../../pages/BleSensorUpdate/BLESensorUpdate")
);
const Notification = React.lazy(() =>
  import("@cleanup/pages/Notification/NotificationPage")
);
const NotificationUpdate = React.lazy(() =>
  import("@cleanup/pages/NotifcationUpdate/NotificationdUpdatePage")
);
const IntegratedHelpPage = React.lazy(() =>
  import("@cleanup/pages/Notification/IntegratedHelp/IntegratedHelpPage")
);
const IntegratedHelpUpdatePage = React.lazy(() =>
  import(
    "@cleanup/pages/Notification/IntegratedHelp/IntegratedHelpUpdatePage.tsx"
  )
);
const Partner = React.lazy(() => import("../../cleanup/pages/Partner/Partner"));
const PartnerCreate = React.lazy(() =>
  import("../../pages/PartnerUpdate/PartnerCreate")
);
const PartnerUpdate = React.lazy(() =>
  import("../../pages/PartnerUpdate/PartnerUpdate")
);
const AiPromptPage = React.lazy(() =>
  import("../../cleanup/AiPromptPage/AiPromptPage")
);
const AiPromptUpdatePage = React.lazy(() =>
  import("../../cleanup/AiPromptPage/AiPromptUpdatePage")
);
const DocAliasPage = React.lazy(() =>
  import("../../cleanup/DocAliasPage/DocAliasPage")
);
const AiConversationPage = React.lazy(() =>
  import("../../cleanup/AiConversationPage/AiConversationPage")
);
const AiConversationViewPage = React.lazy(() =>
  import("../../cleanup/AiConversationPage/AiConversationViewPage")
);

const OAuth2RegisteredClient = React.lazy(() =>
  import("../../cleanup/pages/OAuth2RegisteredClient/OAuth2RegisteredClient")
);
const OAuth2RegisteredClientUpdate = React.lazy(() =>
  import(
    "../../cleanup/pages/OAuth2RegisteredClient/OAuth2RegisteredClientUpdate/OAuth2RegisteredClientUpdate"
  )
);

const DefaultLandingPageRedirect = (): JSX.Element => {
  const loginInfo = useSelector((state: RootState) => state.user);
  const landingPagePath = getHashFromLandingPage(loginInfo);
  return <Redirect to={landingPagePath} />;
};
const DevAccount = React.lazy(() =>
  import("../../cleanup/pages/DevAccount/DevAccount")
);
const DevAccountUpdate = React.lazy(() =>
  import("../../pages/DevAccountUpdate/DevAccountUpdate")
);
const SigfoxAccount = React.lazy(() =>
  import("../../cleanup/pages/SigfoxAccount/SigfoxAccount")
);

const BulkManage = React.lazy(() =>
  import("../../cleanup/pages/BulkManage/BulkManage")
);
const BulkResultsDetail = React.lazy(() =>
  import("../../pages/BulkResultsDetail/BulkResultsDetail")
);
const DeviceUsageProfilePage = React.lazy(() =>
  import("@pages/DeviceUsageProfile/DeviceUsageProfilePage")
);
const UtilizationGraphAndList = React.lazy(() =>
  import("../../pages/UtilizationGraphAndList/UtilizationGraphAndList")
);
const ChannelUpdate = React.lazy(() =>
  import("../../pages/ChannelUpdate/ChannelUpdate")
);

const CallBackUpdatePage = React.lazy(() =>
  import("../../cleanup/pages/CallbacksUpdate/CallBackUpdatePage")
);

const ReportTemplateLibrary = React.lazy(() =>
  import("../../pages/ReportTemplateLibrary/ReportTemplateLibrary")
);

const ReportTemplateLibraryManage = React.lazy(() =>
  import("../../pages/ReportTemplateLibrary/ReportTemplateLibraryManage")
);

const MaintenancePrograms = React.lazy(() =>
  import("../../pages/MaintenancePrograms/MaintenancePrograms")
);
const MaintenanceProgramsManage = React.lazy(() =>
  import("../../pages/MaintenancePrograms/MaintenanceProgramsManage")
);
const BiDashBoardsPage = React.lazy(() =>
  import("@cleanup/pages/BiDashBoards/BiDashBoardsPage")
);
const GeozoneVisitList = React.lazy(() =>
  import("@/cleanup/pages/GeozoneVisit/GeozoneVisitList")
);
const ChannelDataList = React.lazy(() =>
  import("@/cleanup/pages/ThirdPartyDataRecord/ChannelDataList")
);
const MaintenanceDashboard = React.lazy(() =>
  import("../../pages/MaintenanceDashboard/MaintenanceDashboard")
);
const MaintenanceProgramDetails = React.lazy(() =>
  import("../../pages/MaintenanceDashboard/MaintenanceProgramDetails")
);
const MaintenanceProgramsStatistics = React.lazy(() =>
  import(
    "../../cleanup/pages/MaintenancePrograms/MaintenanceProgramsStatistics"
  )
);
const StartMaintenanceProgramBulk = React.lazy(() =>
  import("../../pages/MaintenanceDashboard/StartMaintenanceProgramBulk")
);
const WebhookPage = React.lazy(() =>
  import("@cleanup/pages/Webhooks/WebhookPage")
);
const ThirdPartyData = React.lazy(() =>
  import("@cleanup/pages/ThirdPartyData/ThirdPartyData")
);
const Geozone = React.lazy(() => import("../../pages/Geozone/Geozone"));
const ImportExportGeozones = React.lazy(() =>
  import("../../pages/Geozone/ImportExportGeozones")
);
const PriceBook = React.lazy(() =>
  import("../../pages/PriceBook/PriceBook")
);
const PriceBookUpdate = React.lazy(() =>
  import("../../pages/PriceBook/PriceBookUpdate")
);
const PriceIncreaseUpdate = React.lazy(() =>
  import("../../pages/PriceBook/PriceIncreaseUpdate")
);
const Customer = React.lazy(() => import("../../pages/Customer/Customer"));
const ConsolidatedCustomer = React.lazy(() =>
  import("../../pages/ConsolidatedCustomer/ConsolidatedCustomer")
);
const ConsolidatedCustomerUpdate = React.lazy(() =>
  import("../../pages/ConsolidatedCustomer/ConsolidatedCustomerUpdate")
);
const PriceList = React.lazy(() =>
  import("../../pages/PriceList/PriceList")
);
const BiDashBoard = React.lazy(() =>
  import("../../pages/BiDashBoard/BiDashBoard")
);
const InvoicesPage = React.lazy(() =>
  import("../../cleanup/pages/InvoicesPage/InvoicesPage")
);
const PerformBulkOperation = React.lazy(() =>
  import("@pages/BulkOperations/PerformBulkOperation")
);
const Quotation = React.lazy(() =>
  import("../../cleanup/pages/Quotation/Quotation")
);

const AllDashBoardsPage = React.lazy(() =>
  import("@cleanup/pages/AllDashBoards/AllDashBoardsPage")
);

const AllSiteMapsPage = React.lazy(() =>
  import("@cleanup/pages/AllSiteMaps/AllSiteMapsPage")
);

const SiteMapDetailPage = React.lazy(() =>
  import("@cleanup/pages/AllSiteMaps/SiteMapDetailPage")
);

const QuoteDetailPage = React.lazy(() => import("../../pages/Quote/QuoteDetailPage"));
const QuotesList = React.lazy(() =>
  import("../../cleanup/pages/Quotes/QuotesList")
);
const QuotesStorefront = React.lazy(() =>
  import("../../cleanup/pages/Quotes/QuotesStorefront")
);

export const adminRoutes: RouteConfig[] = [
  {
    path: "/quote_detail",
    component: () => <QuoteDetailPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
    hasMobileMode: true,
  },
  {
    path: "/quote_detail_partner",
    component: () => <QuoteDetailPage isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
    hasMobileMode: true,
  },
  {
    path: "/quotes_storefront",
    component: () => <QuotesStorefront />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/quotes", "/quote_detail"],
    hasMobileMode: true,
  },
  {
    path: "/quotes_storefront_partner",
    component: () => <QuotesStorefront isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/quotes_partner", "/quote_detail_partner"],
    hasMobileMode: true,
  },
  {
    path: "/quotes",
    component: () => <QuotesList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/quote_detail"],
    hasMobileMode: true,
  },
  {
    path: "/quotes_partner",
    component: () => <QuotesList isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/quote_detail_partner"],
    hasMobileMode: true,
  },
  {
    path: "/quotation",
    component: () => <Quotation />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/quotation_detail"],
    hasMobileMode: true,
  },
  {
    path: "/quotation_detail",
    exact: false,
    component: () => <QuotationDetail />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/assets_location",
    component: () => <AssetMap />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: [],
    hasMobileMode: true,
  },
  {
    path: "/asset_browser",
    component: () => <AssetBrowserPage />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/tracked_assets_update",
    component: () => <DeviceDetailPage />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: [],
    hasMobileMode: true,
  },
  {
    path: "/trackers_admin_update",
    exact: false,
    component: () => <DeviceDetailPage defaultMode="SETTING" />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/manufacturing_info_view",
    exact: false,
    component: () => <MainManufacturingInfo />,
    categoryId /*expand parent sidebar menu*/: "", // specific case -> handled in AdminLayout
    subPages /*highlight child sidebar item for*/: ["/trackers_admin_update"],
  },
  {
    path: "/areas",
    exact: false,
    component: () => <Geozone />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/areas_update",
      "/import_export_geozones",
    ],
  },
  {
    path: "/areas_partner",
    exact: false,
    component: () => <Geozone isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/areas_update",
      "/import_export_geozones",
    ],
  },
  {
    path: "/areas_update",
    exact: false,
    component: () => <AreasUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/import_export_geozones",
    exact: false,
    component: () => <ImportExportGeozones />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/infrastructures",
    exact: false,
    component: () => <Infrastructure />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/infrastructures_partner",
    exact: false,
    component: () => <Infrastructure isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/infrastructures_admin",
    exact: false,
    component: () => <Infrastructure />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/infrastructures_update"],
  },
  {
    path: "/infrastructures_update",
    exact: false,
    component: () => <InfrastructuresUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/geolayers",
    exact: false,
    component: () => <Geolayers />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/geolayer_update"],
  },
  {
    path: "/geolayer_update",
    exact: false,
    component: () => <GeolayerUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/site_maps",
    exact: false,
    component: () => <SiteMaps />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/site_map_update"],
  },
  {
    path: "/site_map_update",
    exact: false,
    component: () => <SiteMapUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/geolayer_generator",
    exact: false,
    component: () => <GeolayerGenerator />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/geolayer_generator_manage",
    ],
  },
  {
    path: "/geolayer_generator_manage",
    exact: false,
    component: () => <GeolayerGeneratorManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/manage_alerts",
    exact: false,
    component: () => <AlertRule />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/manage_alerts_update"],
  },
  {
    path: "/manage_alerts_update",
    exact: false,
    component: () => <AlertRuleUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/utilization_scheme",
    exact: false,
    component: () => <UtilizationKpi />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/utilization_scheme_update",
    ],
  },
  {
    path: "/utilization_scheme_update",
    exact: false,
    component: () => <UtilizationKpiUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/manage_visibility_filters",
    exact: false,
    component: () => <VisibilityFilters />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/manage_visibility_filters_update",
    ],
  },
  {
    path: "/manage_visibility_filters_update",
    exact: false,
    component: () => <ManageVisibilityFilters />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/manage_organisation_filters_partner",
    exact: false,
    component: () => <OrganisationFilters isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/manage_partner_organisation_filters_update",
    ],
  },
  {
    path: "/manage_organisation_filters",
    exact: false,
    component: () => <OrganisationFilters />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/manage_organisation_filters_update",
    ],
  },
  {
    path: "/manage_organisation_filters_update",
    exact: false,
    component: () => <ManageOrganisationFilters />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/manage_partner_organisation_filters_update",
    exact: false,
    component: () => <ManageOrganisationFilters />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/flow_definition",
    exact: false,
    component: () => <FlowDefinition />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/flow_settings"],
  },
  {
    path: "/flow_settings",
    exact: false,
    component: () => <FlowSettings />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/process_definition",
    exact: false,
    component: () => <ProcessDefinition />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/process_definition_update",
    ],
  },
  {
    path: "/process_definition_update",
    exact: false,
    component: () => <ProcessDefinitionUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/users_admin",
    exact: false,
    component: () => <User />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/users_admin_update"],
  },

  {
    path: "/users_admin_update",
    exact: false,
    component: () => <UserUpdatePage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/image_library",
    exact: false,
    component: () => <ImageLibrary />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/image_library_manage"],
  },
  {
    path: "/image_library_manage",
    exact: false,
    component: () => <ImageLibraryManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/image_library_all",
    exact: false,
    component: () => (
      <ImageLibrary isPartner={true} path={"image_library_all"} />
    ),
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/image_library_manage"],
  },
  {
    path: "/pricebook",
    exact: false,
    component: () => <PriceBook />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/pricebook_manage",
      "/pricebook_increase",
    ],
  },
  {
    path: "/pricebook_update",
    exact: false,
    component: () => <PriceBookUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/pricebook_increase",
    exact: false,
    component: () => <PriceIncreaseUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/customer",
    exact: false,
    component: () => <Customer />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/customer_detail"],
  },
  {
    path: "/consolidated_customer",
    exact: false,
    component: () => <ConsolidatedCustomer />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/consolidated_customer_update",
    ],
  },
  {
    path: "/consolidated_customer_update",
    exact: false,
    component: () => <ConsolidatedCustomerUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/price_lists",
    exact: false,
    component: () => <PriceList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/price_list_update",
      "/price_list_items",
    ],
  },
  {
    path: "/price_list_update",
    exact: false,
    component: () => <PriceListImportForm />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/price_list_items",
    exact: false,
    component: () => <PriceListItem />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/organization",
    exact: false,
    component: () => <Organization />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/organization_update"],
  },
  {
    path: "/org_demo",
    exact: false,
    component: () => <OrganisationDemoSettings />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/org_demo_manage"],
  },
  {
    path: "/org_demo_manage",
    exact: false,
    component: () => <OrganisationDemoSettingsManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/custom_branding",
    exact: false,
    component: () => <CustomBranding />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/custom_branding_partner",
    exact: false,
    component: () => <CustomBranding isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/diagnostic_organisation",
    exact: false,
    component: () => <DiagnosticPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/single_sign_on",
    exact: false,
    component: () => <SSOSetting />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/user_assertion_mapping_update"],
  },
  {
    path: "/user_assertion_mapping_update",
    exact: false,
    component: () => <UserAssertionMappingUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/default_landing_page",
    exact: false,
    component: () => <OrganizationLandingPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/default_landing_page_partner",
    exact: false,
    component: () => <OrganizationLandingPage isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/invoicing",
    exact: false,
    component: () => <Invoicing />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/invoice_detail", "/quotation_detail"],
  },
  {
    path: "/end_of_life",
    exact: false,
    component: () => <EndOfLifeDevice />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/failed_trackers",
    exact: false,
    component: () => <FailedTrackers />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/beacon_settings",
    exact: false,
    component: () => <BeaconSettings />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/wifi",
    exact: false,
    component: () => <Wifi />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/harvested_cellular",
    exact: false,
    component: () => <HarvestedCellular />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/private_cellular_all",
    exact: false,
    component: () => <PrivateCellular />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/private_cellular",
    exact: false,
    component: () => <PrivateCellular />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/wifi_cellular_mismatch",
    exact: false,
    component: () => <LocationMismatch />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_account",
    exact: false,
    component: () => <SalesforceAccount />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_account_detail",
    exact: false,
    component: () => <SalesforceAccountDetail />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_contact",
    exact: false,
    component: () => <SalesforceContact />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_lead",
    exact: false,
    component: () => <SalesforceLead />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_opportunity",
    exact: false,
    component: () => <SalesforceOpportunity />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_opportunity_detail",
    exact: false,
    component: () => <SalesforceOpportunityDetail />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_quote",
    exact: false,
    component: () => <SalesforceQuote />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_quote_line_item",
    exact: false,
    component: () => <SalesforceQuoteLineItem />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_quote_detail",
    exact: false,
    component: () => <SalesforceQuoteDetail />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_channel_partner",
    exact: false,
    component: () => <SalesforceChannelPartner />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_channel_partner_detail",
    exact: false,
    component: () => <SalesforceChannelPartnerDetail />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/salesforce_user",
    exact: false,
    component: () => <SalesforceUser />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/impartner_account",
    exact: false,
    component: () => <ImpartnerAccount />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/impartner_channel_partner",
    exact: false,
    component: () => <ImpartnerChannelPartner />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/impartner_user",
    exact: false,
    component: () => <ImpartnerUser />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/product_plan",
    exact: false,
    component: () => <ProductPlan />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/partners",
    exact: false,
    component: () => <Partner />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/partners_update",
      "/partners_create",
    ],
  },
  {
    path: "/doc-aliases",
    exact: false,
    component: () => <DocAliasPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/ai-prompts",
    exact: false,
    component: () => <AiPromptPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/ai-prompt-update"],
  },
  {
    path: "/ai-prompt-update",
    exact: false,
    component: () => <AiPromptUpdatePage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/ai-chats",
    exact: false,
    component: () => <AiConversationPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/ai-chat-view"],
  },
  {
    path: "/ai-chat-view",
    exact: false,
    component: () => <AiConversationViewPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/oauth2_registered_client",
    exact: false,
    component: () => <OAuth2RegisteredClient />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/oauth2_registered_client_update",
      "/oauth2_registered_client_create",
    ],
  },
  {
    path: "/oauth2_registered_client_update",
    exact: false,
    component: () => <OAuth2RegisteredClientUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/oauth2_registered_client_create",
    exact: false,
    component: () => <OAuth2RegisteredClientUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/notification",
    exact: false,
    component: () => <Notification />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/notification_update"],
  },
  {
    path: "/notification_update",
    exact: false,
    component: () => <NotificationUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/integrated_help",
    exact: false,
    component: () => <IntegratedHelpPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/integrated_help_update"],
  },
  {
    path: "/integrated_help_update",
    exact: false,
    component: () => <IntegratedHelpUpdatePage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/invoicing_operations",
    exact: false,
    component: () => <InvoicingOperations />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/invoicing_operations_detail",
    ],
  },
  {
    path: "/invoicing_operations_detail",
    exact: false,
    component: () => <InvoicingOperationsDetail />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/invoices",
    exact: false,
    component: () => <InvoicesPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/invoices_detail"],
  },
  {
    path: "/invoice_detail",
    exact: false,
    component: () => <InvoiceDetail />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/invoices_detail",
    exact: false,
    component: () => <InvoiceDetail isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/partners_update",
    exact: false,
    component: () => <PartnerUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/partners_create",
    exact: false,
    component: () => <PartnerCreate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/partners_details",
    exact: false,
    component: () => <OrganisationVisionPartnerUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/ble_sensors",
    exact: false,
    component: () => <BLESensorList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/ble_sensor_list",
    exact: false,
    component: () => <BLESensorList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/ble_sensor_update",
      "/ble_sensor_import",
    ],
  },
  {
    path: "/ble_sensor_partner",
    exact: false,
    component: () => <BLESensorList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/ble_sensor_update",
      "/ble_sensor_import",
    ],
  },
  {
    path: "/ble_sensor_update",
    exact: false,
    component: () => <BLESensorUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/ble_sensor_import",
    exact: false,
    component: () => <ImportBLESensors />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/api-access",
    exact: false,
    component: () => <DevAccount />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/api-access-update"],
  },
  {
    path: "/api-access-update",
    exact: false,
    component: () => <DevAccountUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/sigfox_account",
    exact: false,
    component: () => <SigfoxAccount />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/sigfox_account_update",
      "/sigfox_account_device_type_info",
    ],
  },
  {
    path: "/sigfox_account_update",
    exact: false,
    component: () => <SigfoxAccountUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/stock",
    exact: false,
    component: () => <Stock />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/stock_update"],
  },
  {
    path: "/stock_update",
    exact: false,
    component: () => <StockUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/stock_movement",
    exact: false,
    component: () => <StockMovement isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/stock_movement_view"],
  },
  {
    path: "/stock_movement_admin",
    exact: false,
    component: () => <StockMovement />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/stock_movement_view"],
  },
  {
    path: "/stock_movement_view",
    exact: false,
    component: () => <StockMovementView />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/sigfox_account_device_type_info",
    exact: false,
    component: () => <SigfoxAccountDeviceTypeInfo />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/bulk_operations",
    exact: false,
    component: () => <PerformBulkOperation />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/bulk_operations_admin",
    exact: false,
    component: () => <PerformBulkOperation />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/bulk_operations_partner",
    exact: false,
    component: () => <PerformBulkOperation isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/support_tickets",
    exact: false,
    component: () => <ZendeskSupportTicket />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/zendesk_tickets",
    exact: false,
    component: () => <ZendeskTicket />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/order_tickets",
    exact: false,
    component: () => <ZendeskOrderTicket />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/maintenance_programs",
    exact: false,
    component: () => <MaintenancePrograms />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/maintenance_programs_manage",
    ],
  },
  {
    path: "/maintenance_programs_manage",
    exact: false,
    component: () => <MaintenanceProgramsManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/maintenance_dashboard",
    exact: false,
    component: () => <MaintenanceDashboard />,
    categoryId /*expand parent sidebar menu*/: "maintenance",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/maintenance_done",
    exact: false,
    component: () => <MaintenanceDonePage />,
    categoryId /*expand parent sidebar menu*/: "maintenance",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/maintenance_upcoming",
    exact: false,
    component: () => <MaintenanceUpcomingPage />,
    categoryId /*expand parent sidebar menu*/: "maintenance",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/maintenance_programs_stats",
    exact: false,
    component: () => <MaintenanceProgramsStatistics />,
    categoryId /*expand parent sidebar menu*/: "maintenance",
    subPages /*highlight child sidebar item for*/: [
      "/maintenance_programs_monitored_assets",
    ],
  },
  {
    path: "/maintenance_programs_details",
    exact: false,
    component: () => <MaintenanceProgramDetails />,
    categoryId /*expand parent sidebar menu*/: "maintenance",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/start_maintenance_program",
    exact: false,
    component: () => <StartMaintenanceProgramBulk />,
    categoryId /*expand parent sidebar menu*/: "maintenance",
  },
  {
    path: "/bi_dashboards",
    exact: false,
    component: () => <BiDashBoardsPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/bi_dashboard_manage"],
  },
  {
    path: "/geozonevisit_list",
    exact: false,
    component: () => <GeozoneVisitList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/custom_data_channel/:channelId",
    exact: false,
    component: () => <ChannelDataList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/bi_dashboard_manage",
    exact: false,
    component: () => <BiDashBoardManagePage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/bi_dashboards_partner",
    exact: false,
    component: () => <BiDashBoardsPage isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/bi_dashboard_manage_partner",
    ],
  },
  {
    path: "/bi_dashboard_manage_partner",
    exact: false,
    component: () => <BiDashBoardManagePage isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/bulk_manage",
    exact: false,
    component: () => <BulkManage isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/bulk_results_detail",
      "/bulk_operations",
    ],
  },
  {
    path: "/bulk_manage_admin",
    exact: false,
    component: () => <BulkManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/bulk_operations_admin"],
  },
  {
    path: "/bulk_manage_partner",
    exact: false,
    component: () => <BulkManage isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/bulk_operations_partner"],
  },
  {
    path: "/bulk_results_detail",
    exact: false,
    component: () => <BulkResultsDetail />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/bulk_results_detail_partner",
    exact: false,
    component: () => <BulkResultsDetail isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/bulk_results_detail_system",
    exact: false,
    component: () => <BulkResultsDetail isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/device_usage_profile",
    exact: true,
    component: () => <DeviceUsageProfilePage isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/device_usage_profile_manage",
      "/device_usage_profile_compare",
    ],
  },
  {
    path: "/device_usage_profile_manage",
    exact: false,
    component: () => <DeviceUsageProfileManage isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/device_usage_profile_partner",
    exact: false,
    component: () => <DeviceUsageProfilePage isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/device_usage_profile_manage_partner",
      "/device_usage_profile_compare_partner",
    ],
  },
  {
    path: "/device_usage_profile_manage_partner",
    exact: false,
    component: () => <DeviceUsageProfileManage isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/device_usage_profile_admin",
    exact: true,
    component: () => <DeviceUsageProfilePage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/device_usage_profile_manage_admin",
      "/device_usage_profile_compare_admin",
    ],
  },
  {
    path: "/device_usage_profile_manage_admin",
    exact: false,
    component: () => <DeviceUsageProfileManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/device_usage_profile_compare",
    exact: false,
    component: () => <ProfileComparePage isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/device_usage_profile_compare_partner",
    exact: false,
    component: () => <ProfileComparePage isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/device_usage_profile_compare_admin",
    exact: false,
    component: () => <ProfileComparePage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/api-docs",
    exact: false,
    component: () => <ApiDocs />,
    categoryId /*expand parent sidebar menu*/: "external-api-group-nav-item",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/client-app-api",
    exact: false,
    component: () => <ClientAppApi />,
    categoryId /*expand parent sidebar menu*/: "external-api-group-nav-item",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/role_manager",
    exact: false,
    component: () => <RoleManager isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/role_manager_update"],
  },
  {
    path: "/role_manager_update",
    exact: false,
    component: () => <RoleManagerUpdate />,
    categoryId /*expand parent sidebar menu*/: "admin-experimental",
  },
  {
    path: "/role_manager_admin_update",
    exact: false,
    component: () => <RoleManagerUpdate />,
    categoryId /*expand parent sidebar menu*/: "admin-experimental",
  },
  {
    path: "/role_manager_admin",
    exact: false,
    component: () => <RoleManager />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/profile",
      "/role_manager_admin_update",
    ],
  },
  {
    path: "/internal-api",
    exact: false,
    component: () => <InternalApi />,
    categoryId /*expand parent sidebar menu*/: "system-developer",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/internal_plans",
    exact: false,
    component: () => <InternalPlan />,
    categoryId /*expand parent sidebar menu*/: "system-developer",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/utilization",
    exact: false,
    component: () => <Utilization />,
    categoryId /*expand parent sidebar menu*/: "", // specific case -> handled in AdminLayout
    subPages /*highlight child sidebar item for*/: [
      "/utilization_graph_and_list",
    ],
  },
  {
    path: "/processes",
    exact: false,
    component: () => <Processes />,
    categoryId /*expand parent sidebar menu*/: "", // specific case -> handled in AdminLayout
    subPages /*highlight child sidebar item for*/: ["/process_statistics"],
  },
  {
    path: "/process_statistics",
    exact: false,
    component: () => <ProcessStatistics />,
    categoryId /*expand parent sidebar menu*/: "", // specific case -> handled in AdminLayout
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/manufacturing",
    exact: false,
    component: () => <Manufacturing />,
    categoryId /*expand parent sidebar menu*/: "", // specific case -> handled in AdminLayout
    subPages /*highlight child sidebar item for*/: [
      "/manufacturing_order_detail",
    ],
  },
  {
    path: "/manufacturing_order_detail",
    exact: false,
    component: () => <ManufacturingOrderDetail />,
    categoryId /*expand parent sidebar menu*/: "", // specific case -> handled in AdminLayout
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/suez_dashboard",
    exact: false,
    component: () => <SuezDashBoard />,
    categoryId /*expand parent sidebar menu*/: "dashboard",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/bi_dashboard",
    exact: false,
    component: () => <BiDashBoard />,
    categoryId /*expand parent sidebar menu*/: "dashboard",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/bi_dashboard/:id",
    exact: false,
    component: () => <BiDashBoard />,
    categoryId /*expand parent sidebar menu*/: "dashboard",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/reports",
    exact: false,
    component: () => <Report />,
    categoryId /*expand parent sidebar menu*/: "report",
    subPages /*highlight child sidebar item for*/: ["/create_report"],
  },
  {
    path: "/create_report",
    exact: false,
    component: () => <CreateReport />,
    categoryId /*expand parent sidebar menu*/: "report",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/report_schedule",
    exact: false,
    component: () => <ReportSchedule />,
    categoryId /*expand parent sidebar menu*/: "report",
  },
  {
    path: "/active_alerts_dashboard",
    exact: false,
    component: () => <ActiveAlertsDashboard />,
    categoryId /*expand parent sidebar menu*/: "sidebar-alerts",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/historical_alerts_dashboard",
    exact: false,
    component: () => <HistoricalAlertsDashboard />,
    categoryId /*expand parent sidebar menu*/: "sidebar-alerts",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/active_alerts_list",
    exact: false,
    component: () => <ActiveAlertsList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-alerts",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/historical_alerts_list",
    exact: false,
    component: () => <HistoricalAlertsList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-alerts",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/geozones_dashboard",
    exact: false,
    component: () => <GeozonesDashboard />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/geozones_list",
    exact: false,
    component: () => <GeozonesList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: ["/geozone_individual"],
  },
  {
    path: "/geozones_tag_list",
    exact: false,
    component: () => <GeozonesTagList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/geozone_tags_manage",
    exact: false,
    component: () => <GeozoneTagManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/update_geozone_tag",
    exact: false,
    component: () => <UpdateGeozoneTag />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/asset_tags_manage_admin",
    exact: false,
    component: () => <AssetTagManage isHomeMenu={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/asset_tags_manage",
    exact: false,
    component: () => <AssetTagManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/update_device_tag",
    exact: false,
    component: () => <UpdateDeviceTag />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/system_tag_manage",
    exact: false,
    component: () => <SystemTagManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/system_tag",
    exact: false,
    component: () => <SystemTagList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: ["system_tag_manage"],
  },
  {
    path: "/partner_tag_manage",
    exact: false,
    component: () => <PartnerTagManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/partner_tag",
    exact: false,
    component: () => <PartnerTagList />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: ["partner_tag_manage"],
  },
  {
    path: "/geozone_individual",
    exact: false,
    component: () => <GeozoneStatistics />,
    categoryId /*expand parent sidebar menu*/: "sidebar-geozones",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/utilization_graph_and_list",
    exact: false,
    component: () => <UtilizationGraphAndList />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/channel_update",
    exact: false,
    component: () => <ChannelUpdate />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/callbacks_update",
    exact: false,
    component: () => <CallBackUpdatePage />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/report_template_library",
    exact: true,
    component: () => <ReportTemplateLibrary />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/report_template_library_manage",
    ],
  },
  {
    path: "/report_template_library_manage",
    exact: false,
    component: () => <ReportTemplateLibraryManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/report_template_library_partner",
    exact: true,
    component: () => <ReportTemplateLibrary isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/report_template_library_manage_partner",
    ],
  },
  {
    path: "/report_template_library_manage_partner",
    exact: false,
    component: () => <ReportTemplateLibraryManage isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/",
    exact: true,
    component: () => <DefaultLandingPageRedirect />,
  },
  {
    path: "/factory_upload",
    exact: false,
    component: () => <FactoryUpload />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["factory_upload_update"],
  },
  {
    path: "/factory_upload_update",
    exact: false,
    component: () => <FactoryUploadUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/factory_order_create",
    exact: false,
    component: () => <CreateFactoryOrder />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/trackers_admin",
    exact: true,
    component: () => <AssetTrackersAdmin />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/trackers_admin_update",
      "/import_tracker_settings",
    ],
  },
  {
    path: "/import_tracker_settings_admin",
    exact: true,
    component: () => <ImportTrackerSettings />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/import_tracker_settings_partner",
    exact: true,
    component: () => <ImportTrackerSettings isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/import_tracker_settings",
    exact: true,
    component: () => <ImportTrackerSettings isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/import_infrastructure_settings_admin",
    exact: true,
    component: () => <ImportInfrastructureSettings />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/import_infrastructure_settings_partner",
    exact: true,
    component: () => <ImportInfrastructureSettings isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/import_infrastructure_settings",
    exact: true,
    component: () => <ImportInfrastructureSettings isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/trackers",
    exact: true,
    component: () => <AssetTrackersAdmin isSystem={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/location_history",
    exact: true,
    component: () => <LocationHistory />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/all_dashboards",
    exact: true,
    component: () => <AllDashBoardsPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/all_site_maps",
    exact: true,
    component: () => <AllSiteMapsPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages: ["/site_map_view"],
  },
  {
    path: "/site_map_view/:id",
    exact: true,
    component: () => <SiteMapDetailPage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/trackers_partner",
    exact: true,
    component: () => <AssetTrackersAdmin isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/tracked_assets",
    exact: true,
    component: () => <AssetListReact />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: ["/tracked_assets_update"],
    hasMobileMode: true,
  },
  {
    path: "/tracker_product",
    exact: true,
    component: () => <TrackerProduct />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: ["/tracker_product_detail"],
  },
  {
    path: "/tracker_product_detail",
    exact: true,
    component: () => <TrackerProductDetail />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/battery_calculator",
    exact: true,
    component: () => <BatteryCalculator />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/product_auto_upgrade",
    exact: true,
    component: () => <ProductAutoUpgrade />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: [
      "/product_auto_upgrade_detail",
    ],
  },
  {
    path: "/product_auto_upgrade_detail",
    exact: true,
    component: () => <ProductAutoUpgradeDetail />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/product_regexp_filter",
    exact: true,
    component: () => <ProductRegexpFilter />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: [
      "/product_auto_upgrade_detail",
    ],
  },
  {
    path: "/product_regexp_filter_detail",
    exact: true,
    component: () => <ProductRegexpFilterDetail />,
    categoryId /*expand parent sidebar menu*/: "assets-nav-item",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/webhooks",
    component: () => <WebhookPage />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: ["/callbacks_update"],
  },
  {
    path: "/third_party_data",
    component: () => <ThirdPartyData />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: ["/channel_update"],
  },
  {
    path: "/organization_update",
    component: () => <OrganizationDetail />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/support",
    component: () => <Support />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/support_partner",
    component: () => <Support isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/rma_declaration",
    component: () => <RMADeclaration />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: ["/rma_declaration_manage"],
  },
  {
    path: "/rma_declaration_manage",
    exact: false,
    component: () => <RMADeclarationManage />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/rma_declaration_view",
    exact: false,
    component: () => <RMADeclarationView />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: [
      "/rma_declaration_view_details",
    ],
  },
  {
    path: "/rma_declaration_view_details",
    exact: false,
    component: () => <RMADeclarationViewDetails />,
    categoryId /*expand parent sidebar menu*/: "",
    subPages /*highlight child sidebar item for*/: [],
  },
  {
    path: "/custom_i18n_messages",
    exact: false,
    component: () => <CustomI18nMessages />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/custom_i18n_messages_manage",
    ],
  },
  {
    path: "/custom_i18n_messages_manage",
    exact: false,
    component: () => <CustomI18nMessagesManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/audit_log",
    exact: false,
    component: () => <AuditLog />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/audit_log_view"],
  },
  {
    path: "/audit_log_view",
    exact: false,
    component: () => <AuditLogView />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/audit_log_partner",
    exact: false,
    component: () => <AuditLog isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/audit_log_view_partner"],
  },
  {
    path: "/audit_log_view_partner",
    exact: false,
    component: () => <AuditLogView isPartner={true} />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/legal_document",
    exact: false,
    component: () => <LegalDocument />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/legal_document_import",
    exact: false,
    component: () => <LegalDocumentImport />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/legal_document_send",
    exact: false,
    component: () => <LegalDocumentSend />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/legal_document_template",
    exact: false,
    component: () => <LegalDocumentTemplate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/legal_document_template_manage",
    exact: false,
    component: () => <LegalDocumentTemplateManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/legal_document_view",
    exact: false,
    component: () => <LegalDocumentView />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/metar_weather_location",
    exact: false,
    component: () => <MetarWeatherLocation />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/metar_weather_location_manage",
    ],
  },
  {
    path: "/metar_weather_location_manage",
    exact: false,
    component: () => <MetarWeatherLocationManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/cellular_account",
    exact: false,
    component: () => <CellularAccount />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/cellular_account_manage"],
  },
  {
    path: "/cellular_account_manage",
    exact: false,
    component: () => <CellularAccountManage />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/cellular_sim",
    exact: false,
    component: () => <CellularSim />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: ["/cellular_sim_manage"],
  },
  {
    path: "/automation_rule",
    exact: false,
    component: () => <AutomationRule />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/automation_rule_update",
      "/automation_rule_create",
    ],
  },
  {
    path: "/automation_rule_update",
    exact: false,
    component: () => <AutomationRuleUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/automation_rule_create",
    exact: false,
    component: () => <AutomationRuleCreate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/csm_info",
    exact: false,
    component: () => <CSMInfoUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },

  {
    path: "/csm_comment",
    exact: false,
    component: () => <CSMComment />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
    subPages /*highlight child sidebar item for*/: [
      "/csm_comment_update",
      "/csm_comment_create",
    ],
  },
  {
    path: "/csm_comment_update",
    exact: false,
    component: () => <CSMCommentUpdate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/csm_comment_create",
    exact: false,
    component: () => <CSMCommentCreate />,
    categoryId /*expand parent sidebar menu*/: "sidebar-admin",
  },
  {
    path: "/permission",
    exact: false,
    component: () => <PermissionPage />,
  },
  {
    path: "/no_access",
    exact: false,
    component: () => <NoAccessPage />,
  },
];

export const routes: RouteConfig[] = [
  {
    path: "/login_mobile",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <LoginMobile />
      </Suspense>
    ),
  },
  {
    path: "/login",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: "/oauth2/authorize",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <OAuth2Authorize />
      </Suspense>
    ),
  },
  {
    path: "/logout",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <Logout />
      </Suspense>
    ),
  },
  {
    path: "/confirm",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <Confirm />
      </Suspense>
    ),
  },
  {
    path: "/reset_password/change_password_expires",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <ChangePasswordExpired />
      </Suspense>
    ),
  },
  {
    path: "/reset_password/forget_password",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <ForgetPassword />
      </Suspense>
    ),
  },
  {
    path: "/reset_password/change_password",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <ChangePassword />
      </Suspense>
    ),
  },
  {
    path: "/email_verification",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <EmailVerification />
      </Suspense>
    ),
  },
  {
    path: "/unlock_account",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <UnlockAccount />
      </Suspense>
    ),
  },
  {
    path: "/complete_user_info",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <CompleteUserInfo />
      </Suspense>
    ),
  },
  {
    path: "/confirm-dcr",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <ConfirmDCR />
      </Suspense>
    ),
  },
  {
    path: "/activate_invitation",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <ActivateInvitation />
      </Suspense>
    ),
  },
  {
    path: "/profile",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <Profile />
      </Suspense>
    ),
  },
  {
    path: "/zendesk/sso",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <Helpdesk />
      </Suspense>
    ),
  },
  {
    path: "/jwt",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <Helpdesk />
      </Suspense>
    ),
  },
  {
    path: "/invoice_addendum",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <InvoiceAddendum />
      </Suspense>
    ),
  },
  {
    path: "/403",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <ForbiddenPage />
      </Suspense>
    ),
  },
  {
    path: "/error_400",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <BadRequestPage />
      </Suspense>
    ),
  },
  {
    path: "/asset_link",
    exact: true,
    component: () => (
      <Suspense fallback={<Loading />}>
        <AssetLinkPage />
      </Suspense>
    ),
  },
];

// add all admin routes as 1 route
const adminPath: string[] = [];
adminRoutes.forEach((route) => {
  if (Array.isArray(route.path)) {
    adminPath.push(...route.path);
  } else {
    adminPath.push(route.path);
  }
});

routes.push({
  path: adminPath,
  exact: true,
  component: () => (
    <Suspense fallback={<Loading />}>
      <AppLayout />
    </Suspense>
  ),
});

// add not found catch-all
routes.push({
  path: "/",
  exact: false,
  component: () => (
    <Suspense fallback={<Loading />}>
      <NotFoundPage />
    </Suspense>
  ),
});
